$(document).ready(function () {
    // Get the domain-specific container
    var currentDomain = $('[data-domain="' + window.location.hostname + '"]');

    if (currentDomain.length !== 0) {
        // Variables
        var cutoffHour = currentDomain.find("#cutoffTime").val(); // Format: 21:59:59
        var currentTime = currentDomain.find('#currentTime').val();
        var deliveryDays = parseInt(currentDomain.find('#deliveryDays').val(), 10);
        var orderDate = new Date(currentDomain.find('#orderDate').val());
        var offDays = currentDomain.find('#offDays').val().split(',').map(day => day.trim().toLowerCase());

        // Helper Functions
        function timeToSeconds(timeStr) {
            var timeParts = timeStr.split(":");
            var hours = parseInt(timeParts[0], 10);
            var minutes = parseInt(timeParts[1], 10);
            var seconds = parseInt(timeParts[2] || 0, 10);
            return hours * 3600 + minutes * 60 + seconds;
        }

        function isOffDay(date) {
            var dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
            var dateString = date.toISOString().split('T')[0]; // Format: YYYY-MM-DD
            return offDays.includes(dayNames[date.getDay()]) || offDays.includes(dateString);
        }

        function formatDate(date) {
            var options = { day: 'numeric', month: 'long' };
            return date.toLocaleDateString('en-GB', options); // Example: "19 December"
        }

        function calculateDeliveryDate(startDate, totalDays) {
            var deliveryDate = new Date(startDate);
            var validDays = 0;

            while (validDays < totalDays) {
                deliveryDate.setDate(deliveryDate.getDate() + 1);
                if (!isOffDay(deliveryDate)) {
                    validDays++;
                }
            }

            return deliveryDate;
        }

        // Calculate initial state
        var time1InSeconds = timeToSeconds(cutoffHour);
        var time2InSeconds = timeToSeconds(currentTime);
        var smallTime = time2InSeconds > time1InSeconds;
        if (smallTime) deliveryDays++;

        var finalDeliveryDate = calculateDeliveryDate(orderDate, deliveryDays);
        var resultDate = formatDate(finalDeliveryDate);

        // Countdown variables
        var timeDiffInSeconds = Math.abs(time1InSeconds - time2InSeconds);
        var htmlHrs = smallTime ? 23 - Math.floor(timeDiffInSeconds / 3600) : Math.floor(timeDiffInSeconds / 3600);
        var htmlMins = smallTime ? 59 - Math.floor((timeDiffInSeconds % 3600) / 60) : Math.floor((timeDiffInSeconds % 3600) / 60);
        var htmlSecs = smallTime ? 59 - (timeDiffInSeconds % 60) : (timeDiffInSeconds % 60);
        var totalSeconds = htmlHrs * 3600 + htmlMins * 60 + htmlSecs;

        // Countdown Update Function
        function updateCountdown() {
            if (totalSeconds < 0) {
                totalSeconds = 86400; // Reset to 24 hours
                deliveryDays++;
                finalDeliveryDate = calculateDeliveryDate(orderDate, deliveryDays);
                resultDate = formatDate(finalDeliveryDate);
            }

            // Calculate hours, minutes, seconds
            var remainingHours = Math.floor(totalSeconds / 3600);
            var remainingMinutes = Math.floor((totalSeconds % 3600) / 60);
            var remainingSeconds = totalSeconds % 60;

            // Format countdown message
            var message = `Order within <span>${remainingHours > 0 ? remainingHours + ' Hrs ' : ''}${remainingMinutes > 0 ? remainingMinutes + ' Mins' : ''}</span> to receive ${resultDate}`;

            // Update countdown display
            $('#countdownMessage div').html(message);

            // Decrement total seconds
            totalSeconds--;
        }

        // Start Countdown
        setInterval(updateCountdown, 1000);
        setTimeout(function () {
            $('#countdownMessage').show();
        }, 1100);
    }
});